/**
 * WP Swiper Plugin - Card Slider Integration
 * Version: 1.0.0
 */

(function($) {
    'use strict';
    
    var WPSwiperCardSlider = {
        
        init: function() {
            $(window).on('elementor/frontend/init', this.onElementorFrontendInit.bind(this));
            
            if (typeof elementorFrontend === 'undefined') {
                $(document).ready(this.initSwipers.bind(this));
            }
        },
        
        onElementorFrontendInit: function() {
            elementorFrontend.hooks.addAction('frontend/element_ready/card_slider.default', this.initWidget.bind(this));
        },
        
        initWidget: function($scope) {
            var $swiperContainer = $scope.find('.card-slider');
            if ($swiperContainer.length) {
                this.createSwiper($swiperContainer, $scope);
            }
        },
        
        initSwipers: function() {
            $('.card-slider-wrapper').each(function() {
                var $wrapper = $(this);
                var $swiperContainer = $wrapper.find('.card-slider');
                if ($swiperContainer.length) {
                    WPSwiperCardSlider.createSwiper($swiperContainer, $wrapper);
                }
            });
        },
        
        createSwiper: function($container, $wrapper) {
            if ($container.length === 0) {
                return;
            }
            
            // 获取配置
            var widgetId = $wrapper.find('[class*="card-slider-button-next-"]').attr('class').match(/card-slider-button-next-(\w+)/);
            widgetId = widgetId ? widgetId[1] : '';
            
            var config = $container.data('swiper-config') || {};
            
            var defaultConfig = {
                slidesPerView: config.slidesPerView || 3,
                spaceBetween: config.spaceBetween || 30,
                loop: config.loop !== false,
                navigation: false,
                pagination: false,
                breakpoints: {
                    320: {
                        slidesPerView: 1.6,
                        spaceBetween: 12
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    1024: {
                        slidesPerView: config.slidesPerView || 3,
                        spaceBetween: config.spaceBetween || 30
                    }
                }
            };
            
            // 添加导航
            if (widgetId && $wrapper.find('.card-slider-button-next-' + widgetId).length) {
                defaultConfig.navigation = {
                    nextEl: '.card-slider-button-next-' + widgetId,
                    prevEl: '.card-slider-button-prev-' + widgetId,
                };
            }
            
            // 添加分页
            if (widgetId && $wrapper.find('.card-slider-pagination-' + widgetId).length) {
                defaultConfig.pagination = {
                    el: '.card-slider-pagination-' + widgetId,
                    clickable: true,
                };
            }
            
            try {
                var swiper = new Swiper($container[0], defaultConfig);
                
                // Store swiper instance
                $container.data('swiper-instance', swiper);
                
                // Handle responsive updates
                $(window).on('resize', function() {
                    if (swiper && swiper.update) {
                        swiper.update();
                    }
                });
                
            } catch (error) {
                console.error('WP Swiper Plugin: Error initializing card slider', error);
            }
        },
        
        destroySwiper: function($container) {
            var swiper = $container.data('swiper-instance');
            if (swiper && swiper.destroy) {
                swiper.destroy(true, true);
                $container.removeData('swiper-instance');
            }
        }
    };
    
    WPSwiperCardSlider.init();
    
    window.WPSwiperCardSlider = WPSwiperCardSlider;
    
})(jQuery);
